// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css/onsen-css-components.css
// module id = 505
// module chunks = 1